import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Adds the X-Csrf-Token header to unsafe HTTP requests (POST, PUT, PATCH, DELETE).
 *
 * Angular's HttpClient needs an explicit interceptor when the
 * CSRF cookie name is dynamic (varies per environment).
 * Checked by csrf_check.rb
 */
@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
  private csrfCookieName: string | null = null;

  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(req.method)) {
      const token = this.getCsrfToken();
      if (token) {
        req = req.clone({ headers: req.headers.set('X-Csrf-Token', token) });
      }
    }
    return next.handle(req);
  }

  private getCsrfToken(): string | null {
    if (!this.csrfCookieName) {
      try {
        const $rootScope = this.injector.get('$injector').get('$rootScope');
        this.csrfCookieName = $rootScope.csrfCookieName;
      } catch {
        return null;
      }
    }
    const match = document.cookie.split('; ').find((c) => c.startsWith(`${this.csrfCookieName}=`));
    return match ? decodeURIComponent(match.split('=')[1]) : null;
  }
}
